import "./style.css";

export const ScreenSpinner = () => <span className="spinner" />;
